export const itineraryBuilderEn = {
  pageTitle: 'Itinerary Builder',
  pageTitleFor: 'Itinerary for',
  backToClient: 'Back to client',
  tripTitle: 'Trip',
  publish: 'Publish itinerary',
  publishing: 'Publishing…',
  publishSuccess: 'Trip published successfully.',
  publishError: 'Failed to publish trip. Please try again.',
  publishModalTitle: 'Publish itinerary',
  publishIdLabel: 'Publish ID (client email)',
  publishIdPlaceholder: 'Select client email or type alternative',
  publishIdRequired: 'Please enter a Publish ID (client email).',
  addItem: 'Add item',
  newItem: 'New item',
  destinations: 'Destinations',
  destinationsPlaceholder: 'Select cities (filters List Builder items)',
  sourceFromList: 'Choose from List Builder',
  itemTitle: 'Title',
  itemTitlePlaceholder: 'e.g. Museum visit, Dinner at...',
  itemType: 'Type',
  itemTypes: {
    activity: 'Activity',
    meal: 'Meal',
    accommodation: 'Accommodation',
    transport: 'Transport',
    note: 'Note',
    other: 'Other',
  },
  time: 'Time',
  timePlaceholder: 'e.g. 9:00 AM',
  duration: 'Duration (min)',
  durationPlaceholder: 'Minutes',
  notes: 'Notes',
  notesPlaceholder: 'Optional notes...',
  confirmationNumber: 'Confirmation number',
  confirmationNumberPlaceholder: 'e.g. ABC123 or booking reference',
  dayLabel: 'Day',
  selectDay: 'Select a day',
  activities: 'Activities',
  meals: 'Meals',
  accommodations: 'Accommodations',
  noDates: 'Set trip dates on the client page to build your itinerary.',
  save: 'Save',
  cancel: 'Cancel',
  delete: 'Delete',
  city: 'City',
  cityPlaceholder: 'Select city',
  noListItems: 'No items yet. Use +Add to create new items.',
  noListItemsShort: 'No items',
  listBuilderLink: 'Manage List Builder',
  addNew: 'Add New',
  emptyDayPrompt: 'Pick a city above, then add items from the lists to build the day\'s itinerary. Auto-save is on, Publish when you are ready to give it to your client.',
  selectListItem: 'Select an item from the list.',
  selectDayFirst: 'Select a day first',
  addAccommodation: 'Add accommodation',
  accommodationModalTitle: 'Add accommodation',
  editAccommodationTitle: 'Edit accommodation',
  checkInDate: 'Check-in date',
  checkOutDate: 'Check-out date',
  accommodationDateInvalid: 'Check-out cannot be before check-in.',
  accommodationDatesRequired: 'Please enter check-in and check-out dates.',
  accommodationSection: 'Accommodation',
} as const;
